import moment from 'moment-timezone';

const usedTimezone = 'America/New_York'

export default class FilterHelper {
  static DATE_FORMAT = "YYMMDD"
  static todayInEDT() {
    return moment().tz(usedTimezone)
  }

  static dateToMoment(dateString) {
    return moment(dateString)
  }

  static compareDates(nextShpDateStr, shipDateTimeStr) {
    return FilterHelper.dateToMoment(nextShpDateStr).isSame(shipDateTimeStr, 'day')
  }

  static getNextShipDate(today, holidays) {
    const checkToSkipDay = today => {
      const dayNumber = today.day()
      const isSat = dayNumber === 6
      const isSun = dayNumber === 0
      return isSat || isSun || FilterHelper.isHoliday(today, holidays)
    }

    const LIMIT = 364 // Max number of loop iterations
    let counter = 0
    do {
      today = today.add(1, 'day')
    } while(checkToSkipDay(today) && counter++ < LIMIT)
    return today
  }

  static isHoliday(today, holidays) {
    for (const holiday of holidays) {
      const h = moment(holiday.Date, FilterHelper.DATE_FORMAT).format('YYYY-MM-DD')
      const t = moment(today).format('YYYY-MM-DD')

      if (moment(h).isSame(t)) {
        return true
      }
    }
    return false
  }

  /**
   * Compute the upper bound (inclusive) for an Invoices or Samples
   * date-range filter per the PR #86 spec.
   *
   *   MTD : ge === startOfMonth(le)  -> nextShipDate iff same month as le, else le
   *   YTD : ge === startOfYear(le)   -> nextShipDate iff same year  as le, else le
   *   1YR / 2YR / custom            -> nextShipDate (unconditional)
   *
   * The MTD vs YTD vs YR detection is done by comparing `ge` to
   * startOfMonth(le) / startOfYear(le). On Jan 1 these collide but the
   * MTD and YTD branches yield the same result so it is safe.
   *
   * Name is historical (introduced for Invoices in PR #906); same logic
   * applies to Samples filters per product decision logged in issue #908.
   *
   * Returns a moment normalized to startOf('day').
   */
  static getInvoiceUpperBoundMoment(geMoment, leMoment, holidays) {
    const ge = geMoment.clone().startOf('day')
    const le = leMoment.clone().startOf('day')
    const nextShip = FilterHelper.getNextShipDate(le.clone(), holidays).startOf('day')

    if (ge.isSame(le.clone().startOf('month'), 'day')) {
      // MTD: only stretch into nextShipDate if it stays within le's month
      return nextShip.isSame(le, 'month') ? nextShip : le
    }
    if (ge.isSame(le.clone().startOf('year'), 'day')) {
      // YTD: only stretch into nextShipDate if it stays within le's year
      return nextShip.isSame(le, 'year') ? nextShip : le
    }
    // 1YR / 2YR / custom: stretch to nextShipDate unconditionally
    return nextShip
  }
}
